import React from "react";
import { Button, Icon } from "@axum/ax-design";
import { useClassicView } from "../config/classicView";
import { fetchBlob } from "./functions";
import { Params } from "./customAxios";

type ClickHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

export const ExportExcelButton = ({ onClick }: { onClick: ClickHandler }) => {
  const { classic } = useClassicView();
  if (classic) {
    return <button className="k-button" type="submit" onClick={onClick}>
      Exportar Excel
    </button>;
  }
  return (
    <Button variant="ghost" type="submit" onClick={onClick}>
      <Icon name="export" />Exportar Excel
    </Button>
  );
};

interface DownloadProps {
  endpoint: string;
  params: Params;
  method: string;
  children: React.ReactNode;
}

export const DownloadButton = ({ endpoint, params, method, children }: DownloadProps) => {
  const { classic } = useClassicView();
  const download = () => fetchBlob(endpoint, params, method);
  if (classic) {
    return <button className="k-button" type="submit" onClick={download}>
      {children}
    </button>;
  }
  return (
    <Button variant="primary" type="submit" onClick={download}>
      <Icon name="download" />{children}
    </Button>
  );
};
